import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import environment from "web/script/modules/environment";
import style from "./burger-menu-secondary-header.css";

function BurgerMenuSecondaryHeader({ renderText, onClickEvent }) {
    const iconName = environment.getFeature("rebrand_2020") ? "arrow-icon" : "chevron";
    return (
        <div onClick={onClickEvent} className={style.secondaryMenuHeader}>
            <SVGIcon className={style.menuItemBigChevron} name={iconName} flip />
            {renderText}
        </div>
    );
}

export default BurgerMenuSecondaryHeader;

BurgerMenuSecondaryHeader.propTypes = {
    renderText: PropTypes.string.isRequired,
    onClickEvent: PropTypes.func.isRequired,
};

BurgerMenuSecondaryHeader.defaultProps = {
    renderText: "",
};
